import { render, staticRenderFns } from "./CmgSustainabilityInfo.vue?vue&type=template&id=4b35c318&scoped=true&lang=pug"
import script from "./cmg-sustainability-info.ts?vue&type=script&lang=ts&external"
export * from "./cmg-sustainability-info.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgSustainabilityInfo.vue?vue&type=style&index=0&id=4b35c318&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b35c318",
  null
  
)

export default component.exports